export default __webpack_public_path__ + "static/media/inActiveGrid.5253f0d4.svg";